<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/warehouse/inventory/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('pandiandanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('pandianleixing')">
            <el-select v-model="yt.conditions.inventoryType">
              <el-option :label="$t('ancangku')" :value="0"></el-option>
              <el-option :label="$t('ankuqu')" :value="1"></el-option>
              <el-option :label="$t('anchanpinfenlei')" :value="2"></el-option>
              <el-option :label="$t('zhidingwuliao')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item :label="$t('cangkumingcheng')">-->
          <!--            <yi_data_select :type="'warehouse'" :ids.sync="yt.conditions.ids"-->
          <!--                :idsPath.sync="yt.conditions.warehouseIds">-->
          <!--            </yi_data_select>-->
          <!--          </el-form-item>-->
          <el-form-item :label="$t('pandianzhuangtai')">
            <!--0=待领取,1=待盘点,2=盘点中,3=待审核,4=已完成,5=已作废-->
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('dailingqu')" :value="0"></el-option>
              <el-option :label="$t('daipanidan')" :value="1"></el-option>
              <el-option :label="$t('pandianzhong')" :value="2"></el-option>
              <el-option :label="$t('daishenhe')" :value="3"></el-option>
              <el-option :label="$t('yiwancheng')" :value="4"></el-option>
              <el-option :label="$t('yizuofei')" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          v-if="utils.checkPower('web_wms_warehouse_inventory_create')"
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
            getWarehouse();
            getWarehouseAreaIds();
            getMaterial();
          "
          type="primary"
        >
          {{ $t("xinzeng") }}
        </el-button>
        <el-button v-if="utils.checkPower('web_wms_warehouse_inventory_receive')" size="mini" :disabled="receiveDisabled" @click="receive" plain>
          {{ $t("pilianglingqu") }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()" :loading="exportExcelLoading"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #pandianleixing="scope">
        <!--        盘点类型,0=按仓库,1=按库区,2=按产品分类,3=指定物料-->
        <span v-if="scope.row.inventoryType == 0">{{ $t("ancangku") }}</span>
        <span v-if="scope.row.inventoryType == 1">{{ $t("ankuqu") }}</span>
        <span v-if="scope.row.inventoryType == 2">{{ $t("anchanpinfenlei") }}</span>
        <span v-if="scope.row.inventoryType == 3">{{ $t("zhidingwuliao") }}</span>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="checkInventory(scope.row)">{{ $t("chakan") }} </el-button>
          </el-col>
          <!--          0=待领取,1=待盘点,2=盘点中,3=待审核,4=已完成,5=已作废-->
          <!--处于待领取、待盘点可修改盘点单信息-->
          <el-col :span="0.1" v-if="scope.row.status == 0 || scope.row.status == 1">
            <el-button
              v-if="utils.checkPower('web_wms_warehouse_inventory_update')"
              type="text"
              @click="
                yt.showEditDialog('bianji', scope.row);
                getWarehouse();
                getWarehouseAreaIds();
                getMaterial();
              "
              >{{ $t("bianji") }}
            </el-button>
          </el-col>
          <!--取处于【待领取】状态-->
          <el-col :span="0.1" v-if="scope.row.status == 0">
            <el-button v-if="utils.checkPower('web_wms_warehouse_inventory_receive')" type="text" @click="collect(scope.row)">{{ $t("lingqu") }} </el-button>
          </el-col>
          <!--取处于【待盘点】状态-->
          <el-col :span="0.1" v-if="scope.row.status == 1">
            <el-button type="text" @click="startInventory(scope.row)">{{ $t("kaishipandian") }} </el-button>
          </el-col>
          <!--取处于【盘点中】状态-->
          <el-col :span="0.1" v-if="scope.row.status == 2">
            <el-button v-if="utils.checkPower('web_wms_warehouse_inventory_getItemById')" type="text" @click="enterInventory(scope.row)">{{ $t("pandianluru") }} </el-button>
          </el-col>
          <!--审核盘点-->
          <el-col :span="0.1" v-if="scope.row.status == 3">
            <el-button v-if="utils.checkPower('web_wms_warehouse_inventory_check_button')" type="text" @click="auditInventory(scope.row)">{{ $t("shenhepandian") }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 0 || scope.row.status == 1">
            <el-button v-if="utils.checkPower('web_wms_warehouse_inventory_delete')" :loading="yt.editObj.loading" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/warehouse/inventory/delete')">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <!--0=按仓库,1=按库区,2=按产品分类,3=指定物料-->
          <!--          @change="inventoryTypeChange"-->
          <el-form-item :label="$t('pandianleixing')" required>
            <el-select v-model="yt.editObj.inventoryType">
              <el-option :label="$t('ancangku')" :value="0"></el-option>
              <el-option :label="$t('ankuqu')" :value="1"></el-option>
              <el-option :label="$t('anchanpinfenlei')" :value="2"></el-option>
              <el-option :label="$t('zhidingwuliao')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inventoryType == 0" :label="$t('xuanzecangku')" required>
            <!--            <el-select multiple  size="mini" filterable-->
            <!--                v-model="yt.editObj.warehouseIds" style="width: 20px;">-->
            <!--              <el-option v-for="(item,index) in warehousesList" :label="item.label" :value="item.id"-->
            <!--                  :key="item.id">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <yi_data_select :key="'0'" :multiple="true" :checkStrictly="false" :warehouseLevel="0" :type="'warehouse'" :ids.sync="yt.editObj.warehouseIds"> </yi_data_select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inventoryType == 1" :label="$t('xuanzekuqu')" required>
            <!--            <el-select multiple  size="mini" filterable-->
            <!--                v-model="yt.editObj.warehouseAreaIds" style="width: 20px;">-->
            <!--              <el-option v-for="(item,index) in warehouseAreaIdsList" :label="item.label" :value="item.id"-->
            <!--                  :key="item.id">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <!--            {{yt.editObj.ids}}-->
            <yi_data_select :key="'1'" :multiple="true" :checkStrictly="false" :warehouseLevel="1" :type="'warehouse'" :ids.sync="yt.editObj.warehouseAreaIds"> </yi_data_select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inventoryType == 2" :label="$t('chanpinfenlei')" required>
            <yi_dictionary_select :max="999" multiple :type="'GYLXCPFL'" :ids.sync="yt.editObj.materialValues"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inventoryType == 3" :label="$t('xuanzewuliao')" required>
            <el-select multiple size="mini" filterable v-model="yt.editObj.materialIds" style="width: 20px;">
              <el-option v-for="(item, index) in materialList" :label="item.name + '(' + item.code + ')'" :value="item.id" :key="item.id"> </el-option>
            </el-select>
            <!--            materialList-->
            <!--            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.editObj.materialIds">-->
            <!--            </yi_data_select>-->
          </el-form-item>
          <el-form-item :label="$t('pandianrenyuan')" required>
            <el-select v-model="yt.editObj.type">
              <!--0=自行领取,1=指定人员,-->
              <!--【自行领取】、【指定人员】-->
              <el-option :label="$t('zixinglingqu')" :value="0"></el-option>
              <el-option :label="$t('zhidingrenyuan')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.type == 1" :label="$t('xuanzerenyuan')" required>
            <yi_data_select :max="1" :type="'customer_user'" :ids.sync="yt.editObj.inventoryPersonnel"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('pandianjiesuoshezhi')" required>
            <el-switch v-model="yt.editObj.unlockEnable" @change="$forceUpdate()"> </el-switch>
          </el-form-item>
          <el-form-item :label="$t('pandianjietianshu')" required>
            <el-input v-model="yt.editObj.unlockDay" @input="$forceUpdate()"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/warehouse/inventory/create', beforeAdd)" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!--编辑表单-->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <!--0=按仓库,1=按库区,2=按产品分类,3=指定物料-->
          <el-form-item :label="$t('pandianleixing')" required>
            <el-select v-model="yt.editObj.inventoryType" @change="inventoryTypeChange">
              <el-option :label="$t('ancangku')" :value="'0'"></el-option>
              <el-option :label="$t('ankuqu')" :value="'1'"></el-option>
              <el-option :label="$t('anchanpinfenlei')" :value="'2'"></el-option>
              <el-option :label="$t('zhidingwuliao')" :value="'3'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inventoryType == 0" :label="$t('xuanzecangku')" required>
            <yi_data_select :key="'0'" :multiple="true" :checkStrictly="false" :warehouseLevel="0" :type="'warehouse'" :ids.sync="yt.editObj.warehouseIds"> </yi_data_select>
            <!--            <el-select multiple  size="mini" filterable-->
            <!--                v-model="yt.editObj.warehouseIds" style="width: 20px;">-->
            <!--              <el-option v-for="(item,index) in warehousesList" :label="item.label" :value="item.id"-->
            <!--                  :key="item.id">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <!--            <yi_data_select :type="'warehouse'" :ids.sync="yt.editObj.ids"-->
            <!--                :idsPath.sync="yt.editObj.warehouseIds">-->
            <!--            </yi_data_select>-->
          </el-form-item>
          <el-form-item v-if="yt.editObj.inventoryType == 1" :label="$t('xuanzekuqu')" required>
            <!--            <el-select multiple  size="mini" filterable-->
            <!--                v-model="yt.editObj.warehouseAreaIds" style="width: 20px;">-->
            <!--              <el-option v-for="(item,index) in warehouseAreaIdsList" :label="item.label" :value="item.id"-->
            <!--                  :key="item.id">-->
            <!--              </el-option>-->
            <!--            </el-select>-->
            <yi_data_select :key="'1'" :multiple="true" :checkStrictly="false" :warehouseLevel="1" :type="'warehouse'" :ids.sync="yt.editObj.warehouseAreaIds"> </yi_data_select>

            <!--            <yi_data_select :type="'warehouse'" :ids.sync="yt.editObj.ids"-->
            <!--                :idsPath.sync="yt.editObj.warehouseAreaIds">-->
            <!--            </yi_data_select>-->
          </el-form-item>
          <el-form-item v-if="yt.editObj.inventoryType == 2" :label="$t('chanpinfenlei')" required>
            <yi_dictionary_select :max="999" multiple :type="'GYLXCPFL'" :ids.sync="yt.editObj.materialValues"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inventoryType == 3" :label="$t('xuanzewuliao')" required>
            <el-select multiple size="mini" filterable v-model="yt.editObj.materialIds" style="width: 20px;">
              <el-option v-for="(item, index) in materialList" :label="item.name + '(' + item.code + ')'" :value="item.id" :key="item.id"> </el-option>
            </el-select>
            <!--            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.editObj.materialIds">-->
            <!--            </yi_data_select>-->
          </el-form-item>
          <el-form-item :label="$t('pandianrenyuan')" required>
            <el-select v-model="yt.editObj.type">
              <!--0=自行领取,1=指定人员,-->
              <!--【自行领取】、【指定人员】-->
              <el-option :label="$t('zixinglingqu')" :value="0"></el-option>
              <el-option :label="$t('zhidingrenyuan')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.type == 1" :label="$t('xuanzerenyuan')" required>
            <yi_data_select :max="1" :type="'customer_user'" :ids.sync="yt.editObj.inventoryPersonnel"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('pandianjiesuoshezhi')" required>
            <el-switch v-model="yt.editObj.unlockEnable"> </el-switch>
          </el-form-item>
          <el-form-item :label="$t('pandianjietianshu')" required>
            <el-input v-model="yt.editObj.unlockDay"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/warehouse/inventory/update', beforeAdd)" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!--盘点任务单-->
      <template v-if="yt.editObj.action == 'pandianrenwudan'">
        <div class="dialog-scroller">
          <task_list ref="task_list" :taskOrder="yt.editObj"></task_list>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="saveChangeAddLoading" size="mini" @click="saveChangeAdd" type="primary">
            {{ $t("baocun") }}
          </el-button>
          <el-button :loading="changeAddLoading" size="mini" @click="changeAdd" type="primary">
            {{ $t("tijiaoshenhe") }}
          </el-button>
        </span>
      </template>
      <!-- 审核盘点任务单-->
      <template v-if="yt.editObj.action == 'shenhepanidanpandianrenwudan'">
        <div class="dialog-scroller">
          <task_list ref="task_list" :taskOrder="yt.editObj"></task_list>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="rejectAddLoading" size="mini" @click="rejectAdd" type="danger">
            {{ $t("jujue") }}
          </el-button>
          <el-button :loading="changeApprovedLoading" size="mini" @click="changeApproved" type="primary">
            {{ $t("shnehetongguo") }}
          </el-button>
        </span>
      </template>
      <!--查看-->
      <template v-if="yt.editObj.action == 'chakan'">
        <div class="dialog-scroller">
          <check_list ref="chect_list" :taskOrder="yt.editObj"></check_list>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import task_list from "@@/pages/web/wms/warehouse_inventory/task_list";
import check_list from "@@/pages/web/wms/warehouse_inventory/check_list";
export default {
  name: "web_wms_warehouse_inventory_list",
  components: {
    task_list,
    check_list,
  },
  data() {
    return {
      warehousesList: [],
      warehouseAreaIdsList: [],
      materialList: [],
      exportExcelLoading: false,
      saveChangeAddLoading: false,
      changeAddLoading: false,
      rejectAddLoading: false,
      changeApprovedLoading: false,
      receiveDisabled: true,
      receiveIds: null,
      orderListId: null,
      dataList: [],
      columns: [
        {
          label: "xuanze",
          type: "selection",
        },
        {
          label: "pandiandanhao",
          prop: "no",
          width: 130,
        },
        {
          label: "pandianzhuangtai",
          prop: "status",
          type: "tag",
          //0=待领取,1=待盘点,2=盘点中,3=待审核,4=已完成,5=已作废
          tags: {
            "0": {
              color: "#F759AB",
              text: this.$t("dailingqu"),
            },
            "1": {
              color: "#E6A23C",
              text: this.$t("daipanidan"),
            },
            "2": {
              color: "#419FFF",
              text: this.$t("pandianzhong"),
            },
            "3": {
              color: "#9254DE",
              text: this.$t("daishenhe"),
            },
            "4": {
              color: "#67C23A",
              text: this.$t("yiwancheng"),
            },
            "5": {
              color: "#909399",
              text: this.$t("yizuofei"),
            },
          },
          width: 130,
        },
        // {
        //   label: 'suoshucangku',
        //   prop: 'materialValue',
        //   type: 'dictionary',
        //   key: 'GYLXCPFL',
        //   // width: 130,
        // },
        {
          label: "pandianleixing",
          prop: "inventoryType",
          type: "slot",
          width: 130,
        },
        {
          label: "chuangjianshijian",
          prop: "createTime",
          type: "time",
          width: 130,
        },
        {
          label: "pandiankaishishijian",
          prop: "startInventoryTime",
          type: "time",
          width: 130,
        },
        {
          label: "pandianrenyuan",
          prop: "inventoryPersonnelObject.nickname",
          width: 130,
        },
        {
          label: "chuangjianren",
          prop: "createByObject.nickname",
          width: 130,
        },
        {
          label: "caozuo",
          type: "slot",
          width: 200,
          fixed: "right",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  mounted() {},
  methods: {
    //仓库
    async getWarehouse() {
      let response = await this.http.get("/web/basic/warehouse/list");
      this.warehousesList = response.data;
    },
    // 库区
    async getWarehouseAreaIds() {
      let response = await this.http.get("/web/basic/warehouse/area/list");
      this.warehouseAreaIdsList = response.data;
    },
    //物料
    async getMaterial() {
      let response = await this.http.get("/web/basic/material/list ");
      this.materialList = response.data;
    },
    // inventoryTypeChange(value){
    //   // if(value){
    //   //   if(value==1){
    //   //     this.yt.editObj.warehouseIds = ''
    //   //     delete this.yt.editObj.warehouseIds
    //   //   }
    //   //   if(value==null){
    //   //     this.yt.editObj.warehouseAreaIds = ''
    //   //     delete this.yt.editObj.warehouseAreaIds
    //   //   }
    //   // }
    //
    // },
    beforeAdd(params, url) {
      if (params.unlockEnable == true) {
        params.unlockEnable = 1;
      } else {
        params.unlockEnable = 0;
      }
      return params;
    },
    //保存盘点录入单
    saveChangeAdd() {
      this.saveChangeAddLoading = true;
      console.log("vvvvvnnnn", this.$refs["task_list"]);
      this.dataList = this.$refs["task_list"]._data.task.tableData;
      console.log("vvvvvnnnn111", this.$refs["task_list"]._data.task.tableData);
      if (this.$refs["task_list"]._data.task.tableData) {
        return this.http
          .post("/web/warehouse/inventory/submitForReview?type=0", this.dataList)
          .then((response) => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
            this.saveChangeAddLoading = false;
          })
          .catch((error) => {
            this.utils.errorMessage(this.$t(error));
            this.saveChangeAddLoading = false;
          });
      }
    },
    //提交审核
    changeAdd() {
      this.changeAddLoading = true;
      console.log("vvvvvnnnn", this.$refs["task_list"]);
      this.dataList = this.$refs["task_list"]._data.task.tableData;
      console.log("vvvvvnnnn111", this.$refs["task_list"]._data.task.tableData);
      if (this.$refs["task_list"]._data.task.tableData) {
        return this.http
          .post("/web/warehouse/inventory/submitForReview?type=1", this.dataList)
          .then((response) => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
            this.changeAddLoading = false;
          })
          .catch((error) => {
            this.utils.errorMessage(this.$t(error));
            this.changeAddLoading = false;
          });
      }
    },
    //审核盘点(审核通过)
    changeApproved() {
      this.changeApprovedLoading = true;
      console.log("vvvvvnnnn", this.$refs["task_list"]);
      if (this.$refs["task_list"]._data.pagination.orderId) {
        this.orderListId = this.$refs["task_list"]._data.pagination.orderId;
        return this.http
          .get("/web/warehouse/inventory/approved?id=" + this.orderListId)
          .then((response) => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
            this.changeApprovedLoading = false;
          })
          .catch((error) => {
            this.utils.errorMessage(this.$t(error));
            this.changeApprovedLoading = false;
          });
      }
    },
    //审核盘点(拒绝)
    rejectAdd() {
      this.rejectAddLoading = true;
      console.log("vvvvvnnnn", this.$refs["task_list"]);
      if (this.$refs["task_list"]._data.pagination.orderId) {
        this.orderListId = this.$refs["task_list"]._data.pagination.orderId;
        return this.http
          .get("/web/warehouse/inventory/reject?id=" + this.orderListId)
          .then((response) => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
            this.rejectAddLoading = false;
          })
          .catch((error) => {
            this.utils.errorMessage(this.$t(error));
            this.rejectAddLoading = false;
          });
      }
    },
    selectionChange(items) {
      this.allLists = items;
      this.receiveIds = items.map((item) => {
        return item.id;
      });
      if (this.receiveIds.length > 0) {
        this.receiveDisabled = false;
      } else {
        this.receiveDisabled = true;
      }
    },
    setDefaultValue() {
      this.yt.editObj.unlockEnable = true;
      this.yt.editObj.unlockDay = 15;
    },
    //领取
    receive() {
      this.$confirm(this.$t("shifoulingqupandiandanhao"), this.$t("tishi"), {
        confirmButtonText: this.$t("queding"),
        cancelButtonText: this.$t("quxiao"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 在确定按钮点击时添加loading效果
            instance.confirmButtonLoading = true;
            // 执行操作...
            // 操作完成后，手动关闭对话框
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 2000);
          } else {
            // 取消按钮点击或者点击遮罩层时，直接关闭对话框
            done();
          }
        },
      })
        .then(() => {
          let params = {
            ids: this.receiveIds + "",
          };
          return this.http
            .get("/web/warehouse/inventory/receive", {
              params,
            })
            .then((res) => {
              this.$message.success(this.$t(res.msg));
              this.yt.get(1);
            })
            .catch((error) => {
              this.$message.error(this.$t(error));
            });
        })
        .catch(() => {});
    },
    //操作列领取
    collect(row) {
      this.$confirm(this.$t("shifoulingqupandiandanhao1"), this.$t("tishi"), {
        confirmButtonText: this.$t("queding"),
        cancelButtonText: this.$t("quxiao"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 在确定按钮点击时添加loading效果
            instance.confirmButtonLoading = true;
            // 执行操作...
            // 操作完成后，手动关闭对话框
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 2000);
          } else {
            // 取消按钮点击或者点击遮罩层时，直接关闭对话框
            done();
          }
        },
      })
        .then(() => {
          let params = {
            ids: row.id,
          };
          return this.http
            .get("/web/warehouse/inventory/receive", {
              params,
            })
            .then((res) => {
              this.$message.success(this.$t(res.msg));
              this.yt.get(1);
            })
            .catch((error) => {
              this.$message.error(this.$t(error));
            });
        })
        .catch(() => {});
    },
    //开始盘点
    startInventory(row) {
      this.$confirm(this.$t("shifoukaishipandian"), this.$t("tishi"), {
        confirmButtonText: this.$t("queding"),
        cancelButtonText: this.$t("quxiao"),
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row.id,
          };
          return this.http
            .get("/web/warehouse/inventory/start", {
              params,
            })
            .then((res) => {
              this.$message.success(this.$t(res.msg));
              this.yt.get(1);
            })
            .catch((error) => {
              this.$message.error(this.$t(error));
            });
        })
        .catch(() => {});
    },
    //盘点录入
    enterInventory(row) {
      this.yt.showEditDialog("pandianrenwudan", row, "80%");
    },
    exportExcel() {
      this.exportExcelLoading = true;
      let params = this.yt.conditions;
      return this.http
        .get("/web/report/export/warehouse_inventory_export", {
          params,
        })
        .then((res) => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
          this.exportExcelLoading = false;
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.exportExcelLoading = false;
        });
    },
    //审核盘点
    auditInventory(row) {
      this.yt.showEditDialog("shenhepanidanpandianrenwudan", row, "80%");
    },
    //查看
    checkInventory(row) {
      this.yt.showEditDialog("chakan", row, "80%");
    },
  },
};
</script>
